<template>
  <div
    :id="accordionName"
    class="collapse"
    ref="collapseContainer"
    v-bind:class="{ expanded: susactive, 'collapse-active': collapsed }"
    v-if="!hideUnavailableFacets"
  >
    <details class="accordion" open>
      <summary><slot name="title"></slot></summary>
      <div><slot name="content"></slot></div>
    </details>
    <!-- <button
      class="collapse__title"
      data-toggle="dropdown"
      v-bind:data-target="`#${id}`"
      v-bind:aria-expanded="`${collapsed ? 'true' : 'false'}`"
      v-bind:aria-controls="id"
      :ref="`toggle-${id}`"
      v-on:click="toggleCollapse(), `${!collapsed ? '' : triggerGA()}`"
    >
      <img
        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjA2MjUgMTAuNUgxNi45NDI1VjEyLjM3SDE1LjA2MjVWMTAuNVpNMTUuMDYyNSAxNC4wNkgxNi44NDI1VjIxLjVIMTUuMTEyNUwxNS4wNjI1IDE0LjA2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS4wNjI1IDE0LjA2TDE1LjExMjUgMjEuNUgxNi44NDI1VjE0LjA2SDE1LjA2MjVaTTE1LjA2MjUgMTAuNVYxMi4zN0gxNi45NDI1VjEwLjVIMTUuMDYyNVoiIGZpbGw9IiMyMTM2MkMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA1LjVDMTAuMjAxIDUuNSA1LjUgMTAuMjAxIDUuNSAxNkM1LjUgMjEuNzk5IDEwLjIwMSAyNi41IDE2IDI2LjVDMjEuNzk5IDI2LjUgMjYuNSAyMS43OTkgMjYuNSAxNkMyNi41IDEwLjIwMSAyMS43OTkgNS41IDE2IDUuNVpNNC41IDE2QzQuNSA5LjY0ODczIDkuNjQ4NzMgNC41IDE2IDQuNUMyMi4zNTEzIDQuNSAyNy41IDkuNjQ4NzMgMjcuNSAxNkMyNy41IDIyLjM1MTMgMjIuMzUxMyAyNy41IDE2IDI3LjVDOS42NDg3MyAyNy41IDQuNSAyMi4zNTEzIDQuNSAxNloiIGZpbGw9IiMyMTM2MkMiLz4KPC9zdmc+Cg=="
        :data-src="collapseIcon"
        :alt="titleText"
        class="icon-accordion lazyload"
        v-if="productPage"
      />
      <slot name="title"></slot>
      <slot name="icon" />
      <svg v-if="productPage" class="icon-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="#21362C" stroke-width="2" />
      </svg>
        
      <span class="collapse__hamburger-wrapper">
        <button
          class="collapse__hamburger"
          v-bind:class="{ 'collapse__hamburger--opened': collapsed }"
          :ref="`close-${id}`"
          @click:prevent="toggleCollapse(), `${!collapsed ? '' : triggerGA()}`"
        >
          <span></span>
          <span></span>
        </button>
      </span>
    </button>
    <div
      class="collapse__content"
      v-bind:id="id"
      v-bind:class="{ 'collapse__content--collapsed': collapsed }"
    >
      <slot name="content"></slot>
    </div> -->
    <!-- <div
      class="click-overlay"
      @click="overlayClick"
      v-if="isClickOverlayEnabled & collapsed"
    ></div> -->
  </div>
</template>

<script>
export default {
  name: 'collapse',
  props: {
    expanded: { require: false, default: false },
    productPage: { type: Boolean, require: false, default: false },
    filterPage: { type: Boolean, require: false, default: false },
    isClickOverlayEnabled: { require: false, default: false },
    tagging: { require: false },
    sustainabilitystatus: { type: Object, required: false, default: false },
    collapseIcon: { type: String, require: false },
    accordionName: { type: String, require: false },
    titleText: { type: String, require: false },
  },
  data() {
    return {
      // collapsed: false,
      hideUnavailableFacets: false,
      susactive: false,
      id: `collapse${Math.floor(Math.random() * 1000000) + 1}`,
      pdpstickybuynowactive: false,
      payload: false,
    };
  },
  computed: {
    collapseSlotsCollection() {
      return this.$slots.title[0].children[0].text;
    },
  },
  methods: {
    // toggleCollapse() {
    //   if (this.productPage && window.innerWidth < 767) {
    //     Array.prototype.forEach.call(this.$parent.$children, item => {
    //       item.collapsed = false;
    //       if (item.$options.name === 'sustainability') {
    //         item.$children[item.$children.length - 1].collapsed = false;
    //       }
    //     });
    //     if (this.$parent.$parent.$el.classList.contains('collapse-list')) {
    //       Array.prototype.forEach.call(this.$parent.$parent.$children, item => {
    //         item.collapsed = false;
    //       });
    //     }
    //     if (!this.$el.classList.contains('collapse-active')) {
    //       this.collapsed = !this.collapsed;
    //     }
    //     let collapseOffsetTop =
    //       document.querySelector('.pdp-collapse').parentElement.offsetTop -
    //       (this.pdpstickybuynowactive ? 160 : 90);
    //     window.scrollTo({ top: collapseOffsetTop, behavior: 'smooth' });
    //   }
    //   if (this.filterPage && this.$parent.$parent.$options.name === 'filters') {
    //     Array.prototype.forEach.call(this.$parent.$parent.$children, item => {
    //       if (item.$children.length !== 0) {
    //         if (item.$children[0].$options.name === 'collapse' && item.$children[0].collapsed) {
    //           item.$children[0].collapsed = false;
    //         }
    //       }
    //     });
    //     if (!this.$el.classList.contains('collapse-active')) {
    //       this.collapsed = !this.collapsed;
    //     }
    //   }
    //   if (!this.productPage && !this.filterPage) {
    //     this.collapsed = !this.collapsed;
    //   }
    //   var target = this.collapsed ? `close-${this.id}` : `toggle-${this.id}`;
    //   this.$refs[target].focus();
    // },
    // overlayClick() {
    //   this.collapsed = false;
    // },
    // triggerGA() {
    //   if (this.tagging !== undefined) {
    //     try {
    //       window.dataLayer.push(this.tagging);
    //     } catch (error) {
    //       console.warn(error);
    //     }
    //   }
    // }
  },
  mounted() {
    if (
      this.sustainabilitystatus &&
      this.sustainabilitystatus.active &&
      (this.sustainabilitystatus.active === 'True' ||
        this.sustainabilitystatus.active) &&
      !this.productPage
    ) {
      this.susactive = true;
    }
    // if (this.accordionName && window.location.hash.includes(this.accordionName)){
    //   this.toggleCollapse()
    // } else {
    //   if (this.expanded) {
    //     this.toggleCollapse();
    //   }
    //   this.$nextTick(function() {
    //     if(this.$refs.collapseContainer && this.$refs.collapseContainer.classList.contains('expanded')){
    //         this.toggleCollapse();
    //     }
    //   });
    // }
    if (window.eventBus) {
      window.eventBus.$on('pdp-mobile-collapse', (payload) => {
        this.pdpstickybuynowactive = payload;
      });
    }
  },
};
</script>
